// extracted by mini-css-extract-plugin
export var banner = "_ax-0";
export var closeButton = "_ax-2";
export var greenCheckmark = "_ax-3";
export var hereLink = "_ax-4";
export var titleIcon = "_ax-1";